export const ContributionPurchaseType = {
  course: 'course',
  oneToOne: 'one-to-one',
};
